import React, { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import { message } from "antd";
import useUserStore from "../../stores/store";
import OrderListComponent from "../../component/super-admin/orders/OrderListComponent";
import { getOrderList } from "../../services/super-admin/disbursement-service";

export default function OrderList() {
  const { user } = useUserStore();
  const [loading, setLoading] = useState(true);
  const [salesFilter, setSalesFilter] = useState({
    restaurantId: "",
    searchText: "",
    fromDate: "",
    toDate: "",
    paymentStatus: "",
    orderStatus: "",
    page: 1,
    perPage: 10,
  });

  const [tableData, setTableData] = useState({
    records: [],
    pagination: { current: 1, pageSize: 10, total: 0 },
  });

  const [isFilterClear, setIsFilterClear] = useState(false);

  async function fetchSalesReportList(filter) {
    try {
      setLoading(true);
      const result = await getOrderList(filter, user.token.token);

      setTableData({
        records: result.records,
        pagination: {
          current: result.pagination.page,
          pageSize: result.pagination.perPage,
          total: result.pagination.total,
        },
      });
    } catch (err) {
      console.log("====err===", err);
      message.error("Something went wrong in serverside. Try again later.");
      return;
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  /** init **/
  useEffect(() => {
    fetchSalesReportList(salesFilter);
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchSalesReportList(salesFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData(page = 0, perPage = 0) {
    // const tempFilter = { ...salesFilter, page: 1, perPage: 10 };
    const tmpFilter = Object.assign({}, salesFilter, {
      page: page ? page : salesFilter.page,
      perPage: perPage ? perPage : salesFilter.perPage,
    });

    fetchSalesReportList(tmpFilter);
  }


  return (
    <section>
      <div className="flex flex-col">
        <Header title={""} menu={constants.SUPER_MENU.ORDERS} currentMenuKey={'T_54_S_54_L_1'}/>
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Orders`} menu={constants.SUPER_MENU.ORDERS} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            Orders
          </h1>

          <OrderListComponent
            tableData={tableData}
            setSalesFilter={setSalesFilter}
            handleFilterApply={onHandleFilterData}
            setIsFilterClear={setIsFilterClear}
            loading={loading}
          />
        </div>
      </div>
    </section>
  );
}
